import React, { useState } from "react";

import { ProductSearch } from "../components";
import ProductPrices from "../product/components/ProductPrices";
// Shared dark "insights surface" styling that ProductSearch/ProductPrices rely
// on when rendered standalone here — do not edit (see PricingPage.scss).
import "./Listing/rc-product-insights.scss";
import "./PricingPage.scss";

const PricingPage = ({ user }) => {
  const [product, setProduct] = useState(null);

  const canSeePricesInfo =
    user?.is_admin ||
    user?.can_see_market_prices ||
    user?.can_see_trade_prices;

  if (!canSeePricesInfo) {
    return null;
  }

  return (
    <main className="rc-pricing-page">
      <header className="rc-pricing-page__header">
        <h1 className="rc-pricing-page__title">Pricing</h1>
        <p className="rc-pricing-page__subtitle">
          Search for a product to view price analysis, historical data, and deal finder listings.
        </p>
      </header>

      <div className="rc-pricing-page__search">
        <ProductSearch onSelect={setProduct} />
      </div>

      {product && (
        <ProductPrices product={product} variant="standalone" />
      )}
    </main>
  );
};

export default PricingPage;
